import React, {Component} from 'react';
import {
	Button,
	ContentSwitcher,
	Link,
	Select,
	SelectItem,
	SelectGroup,
	Slider,
	Switch,
	Tabs,
	Tab,
	Tile,
	Toggle,
	ToggleSmall
} from 'carbon-components-react';
import { Renew16 } from '@carbon/icons-react';

import CCButton from '../../components/CCButton';
import PropertyComponent from '../../components/PropertyComponent';
import ParameterSlider from '../../components/ParameterSlider';
import ParameterToggle from '../../components/ParameterToggle';
import { IndexedParameterSelect, IndexedParameterValue } from '../../components/IndexedParameterSelect';
import DevicePropertyButton from '../../components/DevicePropertyButton';
import DevicePropertySelect from '../../components/DevicePropertySelect';
import DevicePropertyToggle from '../../components/DevicePropertyToggle';
import LoggingToggle from '../../components/LoggingToggle';
import MidiDevicesDialogWrapper from '../../components/MidiDevicesDialogWrapper';
import PresetGrid from '../../components/PresetGrid';
import {
	FirmwareVersionField,
	ErrorCodeField,
	PSUVoltageField,
	MidiChannelSelector
} from '../../components/ConfigSettings';

import * as midi from '../../js/rpl_midi.js';

midi.setProductId(0x01, 0x08, 'Tensor');
midi.initialize();

class ExprSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return <Slider min="0" max="100" step="0.1" stepMultiplier="40" labelText={this.labelText} onChange={this.handleChange} value={this.state.value} disabled={this.state.disabled} hideTextInput="1"/>
	}

	handleChange(props) {
		var newValue = Number(props.value);
		this.setState({value: newValue});
		midi.setParameterValue(this.propId, newValue / 100);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue / 127);
	}

	setValue(x) {
		// Because the property ID has bit 0x2000 set, rpl_midi does not
		// scale the value
		this.setState({value : 100 * x / 8388608.0});
	}
}


/*
 * Tensor expression toggle.  We store the destination property value
 * (param ID), because each slot is dedicated to a single parameter
 * (in order).  It predates the more general ControlPort implementation.
 */
class ExprToggle extends Toggle {
	constructor(props) {
		super(props);

		this.handleToggle = this.handleToggle.bind(this);

		this.propId = props.propId;
		this.propValue = props.propValue;

		this.state = {
			value : 0
		};
	}

	render() {
		return <Toggle labelA="" labelB=""
				toggled={this.state.value != 0}
				onChange={function noRefCheck(){}}
				onToggle={this.handleToggle} />
	}

	handleToggle(on) {
		var newValue = on ? 1 : 0;
		this.setState({value : newValue});

		/* each toggle is assigned to a specific destination parameter */
		var propValue = on ? this.propValue : 0;
		midi.setDeviceProperty(this.propId, [0, 0, 0, propValue]);
	}

	setValue(x) {
		this.setState({value: x});
	}

	componentDidMount() {
		if (this.propId !== undefined) {
			midi.addPropertySubscriber(this.propId, this);
		}
	}

	componentWillUnmount() {
		if (this.propId !== undefined) {
			midi.removePropertySubscriber(this.propId, this);
		}
	}
}

class TensorExprDestination extends React.Component {
	constructor(props) {
		super(props);

		this.destName   = props.destName;
		this.destPropId = props.destPropId;
		this.destValue  = props.destValue;
		this.minPropId  = props.minPropId;
		this.maxPropId  = props.maxPropId;
	}

	render() {
		return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
					{this.destName}
	  			  </div>
	  			  <div className="bx--col-sm-1 bx--col-md-1 bx--col-lg-1">
				    <ExprToggle propId={this.destPropId} propValue={this.destValue}/>
				  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.minPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.maxPropId}/>
	  			  </div>
	  			</div>
		);
	}
}

class TensorExprDestinations extends React.Component {

	createDestinations() {
		var children = [];

		children.push(<TensorExprDestination
						destName="Speed"
						destPropId={midi.PROPERTY_EXPR_DEST_1}
						destValue={1}
						minPropId={midi.PROPERTY_EXPR_MIN_1}
						maxPropId={midi.PROPERTY_EXPR_MAX_1}
					  />);

		children.push(<TensorExprDestination
						destName="Time"
						destValue={2}
						destPropId={midi.PROPERTY_EXPR_DEST_2}
						minPropId={midi.PROPERTY_EXPR_MIN_2}
						maxPropId={midi.PROPERTY_EXPR_MAX_2}
					  />);

		children.push(<TensorExprDestination
						destName="Pitch"
						destValue={3}
						destPropId={midi.PROPERTY_EXPR_DEST_3}
						minPropId={midi.PROPERTY_EXPR_MIN_3}
						maxPropId={midi.PROPERTY_EXPR_MAX_3}
					  />);

		children.push(<TensorExprDestination
						destName="Blend"
						destValue={4}
						destPropId={midi.PROPERTY_EXPR_DEST_4}
						minPropId={midi.PROPERTY_EXPR_MIN_4}
						maxPropId={midi.PROPERTY_EXPR_MAX_4}
					  />);

		children.push(<TensorExprDestination
						destName="Rand"
						destValue={5}
						destPropId={midi.PROPERTY_EXPR_DEST_5}
						minPropId={midi.PROPERTY_EXPR_MIN_5}
						maxPropId={midi.PROPERTY_EXPR_MAX_5}
					  />);

		return children;
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				Destination
	  			  </div>
	  			  <div className="bx--col-sm-1 bx--col-md-1 bx--col-lg-1">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Heel (Min)
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Toe (Max)
	  			  </div>
	  			</div>
				{this.createDestinations()}
			</div>
		);
	}
}

class RemoteModeSelector extends PropertyComponent {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	createButtonAssignments() {
		if (this.state.value == 0) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 1</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 2</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 3</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 4</div>
	  			</div>
			);
		} else if (this.state.value == 1) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">HOLD</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">ON</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 1</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 2</div>
	  			</div>
			);
		} else if (this.state.value == 2) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Rec/Ovr</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Play/Stop</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Play Once</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Toggle</div>
	  			</div>
			);
		} else if (this.state.value == 3) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">SPEED</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">TIME</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">PITCH</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">RAND</div>
	  			</div>
			);
		}
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <Select labelText="Remote Mode" value={this.state.value} onChange={this.handleChange}>
	  				<SelectItem text="Mode 1 - Presets 1-4" value="0"/>
	  				<SelectItem text="Mode 2 - Stomp & Presets" value="1"/>
	  				<SelectItem text="Mode 3 - Loop Sampler" value="2"/>
	  				<SelectItem text="Mode 4 - Toggle Knobs" value="3"/>
	  			  </Select>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">A</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">B</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">C</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">D</div>
	  			</div>
				{this.createButtonAssignments()}
			</div>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	setValue(x) {
		this.setState({value : x });
	}
}

const props = {
  exprSlider: {
	  hideTextInput: 1,
	  min: 0,
	  max: 100,
	  step: 0.1,
	  stepMultiplier: 40,
	  labelText: null,
  },
  tabs: {
    selected: 0,
    triggerHref: '#',
    role: 'navigation',
  },
  tab: {
    href: '#',
    role: 'presentation',
    tabIndex: 0,
  },
};

class HoldModeSelect extends IndexedParameterSelect {
	fromCCValue(ccValue) {
		var value = Math.floor(ccValue / this.ccMultiplier);
		switch (value) {
			case 0:	// Next
				value = 2;
				break;
			case 1:	// Replace
				value = 0;
				break;
			case 2:	// Overdub
				value = 1;
				break;
		}


		return value;
	}
}

class LoopDirSelect extends IndexedParameterSelect {
	fromCCValue(ccValue) {
		var value = Math.floor(ccValue / this.ccMultiplier);
		switch (value) {
			case 0:	// Reverse
				value = 2;
				break;
			case 1:	// Alternate
				value = 1;
				break;
			case 2:	// Forward
				value = 0;
				break;
		}


		return value;
	}
}

const EditorPage = () => {
  return (
    <div className="bx--grid bx--grid--full-width landing-page">
      <div className="bx--row editor-page__status">
        <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-4">
	  		Status:&nbsp;
	  	    <span id="device-status"></span>
	    </div>
        <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">
	      <Button
	        className="editor-page__statusbtn"
	        disabled={false}
	        hasIconOnly={false}
	        iconDescription="Refresh"
	        kind="primary"
	        onClick={function noRefCheck(){midi.findMIDIDevice()}}
	        onFocus={function noRefCheck(){}}
	        renderIcon={Renew16}
	        size="default"
	        tabIndex={0}
	        tooltipAlignment="center"
	        tooltipPosition="bottom"
	        type="button"
	      >Refresh</Button>
	    </div>
      </div>
      <div className="bx--row landing-page__r2">
	    <div className="bx--col bx--no-gutter">
	      <Tabs {...props.tabs}>
	        <Tab {...props.tab} label="Edit">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Speed" propId={0} ccNum={20}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Time" propId={1} ccNum={21}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Pitch" propId={2} ccNum={22}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Blend" propId={3} ccNum={23}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Rand" propId={4} ccNum={24}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Loop Decay" propId={12}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Pitch Glide" propId={13}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="MIDI Transpose (not saved)" propId={14}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<ParameterToggle labelText="Hold Switch" labelA="Momentary" labelB="Latch" propId={8199} ccNum={85}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<HoldModeSelect labelText="Hold Mode" propId={8197} ccNum={28} ccMultiplier={42.66666667}>
	  				  <IndexedParameterValue value="1" text="Overdub"/>
	  				  <IndexedParameterValue value="0" text="Record"/>
	  				  <IndexedParameterValue value="2" text="Next"/>
	  				</HoldModeSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<LoopDirSelect labelText="Loop Direction" propId={8198} ccNum={29} ccMultiplier={42.66666667}>
	  				  <IndexedParameterValue value="0" text="Forward"/>
	  				  <IndexedParameterValue value="1" text="Alternate"/>
	  				  <IndexedParameterValue value="2" text="Reverse"/>
	  				</LoopDirSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-4">
	  				<ParameterToggle labelText="On Switch" labelA="Momentary" labelB="Latch" propId={8200} ccNum={86}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <h3>Loop Sampler</h3>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				<CCButton kind="secondary" textLabel="Rec" ccNum={87} onValue={127}/>
	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				<CCButton kind="secondary" textLabel="Over" ccNum={87} onValue={96}/>
	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				<CCButton kind="secondary" textLabel="Loop" ccNum={87} onValue={64}/>
	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				<CCButton kind="secondary" textLabel="Once" ccNum={87} onValue={48}/>
	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				<CCButton kind="secondary" textLabel="Stop" ccNum={87} onValue={24}/>
	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-2">
	  				<CCButton kind="secondary" textLabel="Clear" ccNum={87} onValue={0}/>
	  			  </div>
	  			</div>
			  </div>
	        </Tab>
	        <Tab {...props.tab} label="Ctrl Port">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-ctrl">
	  			Expression destinations are saved to presets.  Click Save button at bottom of page to save global configuration.
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  				<DevicePropertySelect labelText="CTRL Port Mode" propId={midi.PROPERTY_CTRL_MODE}>
	  				  <SelectItem text="Off" value="0"/>
	  				  <SelectItem text="Expression" value="1"/>
	  				  <SelectItem text="Remote" value="3"/>
	  				  <SelectItem text="MIDI In (TRS) (v1.2+)" value="4"/>
	  				</DevicePropertySelect>

	  			  </div>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Expression</h1>
	  			</div>
	  			<TensorExprDestinations/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  				<p>If no destinations are set, the expression pedal morphs from normal<br/>
	  				playback (heel) to the current SPEED, TIME, and PITCH settings (toe).</p>
  				</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Remote</h1>
	  			</div>
	  			<RemoteModeSelector propId={midi.PROPERTY_REMOTE_BANK}/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div class="bx--btn-set">
	  				<DevicePropertyButton kind="secondary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[0]} refreshProps={true}>
	  				  Revert
	  				</DevicePropertyButton>
	  				<DevicePropertyButton kind="primary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[1]}>
	  				  Save
	  				</DevicePropertyButton>
	  			  </div>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Preset">
	  		  <PresetGrid numProgs={31}/>
	        </Tab>
	        <Tab {...props.tab} label="Config">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-config">
	  			<FirmwareVersionField propId={midi.PROPERTY_FIRMWARE_VERSION}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			<PSUVoltageField propId={midi.PROPERTY_PSU_VOLTAGE}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			<ErrorCodeField propId={midi.PROPERTY_ERROR_CODE}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Max. Input Level" propId={midi.PROPERTY_MAX_INPUT_LEVEL}>
	  			    <SelectItem text="+7 dBu" value="1"/>
	  			    <SelectItem text="+5 dBu" value="2"/>
	  			    <SelectItem text="+0.5 dBu" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Input/Output Configuration" propId={midi.PROPERTY_IO_CONFIG}>
	  			    <SelectItem text="Mono In / Mono Out" value="0"/>
	  			    <SelectItem text="Mono In / Stereo Out" value="1"/>
	  			    <SelectItem text="Stereo Dry / Mono Wet" value="2"/>
	  			    <SelectItem text="Stereo In / Stereo Out" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Bypass Mode" propId={midi.PROPERTY_BYPASS_MODE}>
	  			    <SelectItem text="Auto" value="0"/>
	  			    <SelectItem text="Analog" value="1"/>
	  			    <SelectItem text="DSP" value="2"/>
	  			    <SelectItem text="Analog + FX Level" value="4"/>
	  			    <SelectItem text="Kill Dry" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <MidiChannelSelector propId={midi.PROPERTY_MIDI_CHANNEL}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Program Change Ignores Blend (v1.2.4+)" labelA="Off" labelB="Ignore" propId={midi.PROPERTY_PROG_LOAD_IGNORE_MIX}/>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Help">
			  <h3>Resources</h3>
  				<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link><br/>
				<Link href="http://www.redpandalab.com/downloads/">User Manuals and Firmware Updates</Link><br/>
				<Link href="http://www.redpandalab.com/contact/">Contact Us</Link><br/>

	  		  <h3>Expression Pedal</h3>
  				<p>To assign the expression pedal to any combination of knobs:
  				<ol>
  				  <li>1. Hold the right footswitch while pluggin in the expression pedal (right LED will blink orange 3x).</li>
  				  <li>2. Move expression pedal to the heel down position.</li>
  				  <li>3. Adjust knobs for the desired sound.</li>
  				  <li>4. Move expression pedal to the toe down position.</li>
  				  <li>5. Adjust knobs for the desired sound.</li>
  				  <li>6. Hold the right footswitch for 2 seconds to save (right LED will blink green).</li>
  				</ol>
  				</p>
	
 			  <h3>Limitations</h3>
				<ul>
  	  		  	  <li>The web editor does not reflect changes made by another MIDI device.
  	  			      Hit Refresh to update.</li>
				</ul>

 			  <h3>Troubleshooting</h3>
	  		  <div className="bx--row editor-page__tab-help">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <MidiDevicesDialogWrapper/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <LoggingToggle/>
	  			  </div>
	  		  </div>
	        </Tab>
	      </Tabs>
	    </div>
      </div>
      <div className="bx--row landing-page__r3">
      </div>
    </div>
  );
};

export default EditorPage;

